import { Pipe, PipeTransform } from '@angular/core';
import { DecimalPipe, PercentPipe, CurrencyPipe } from '@angular/common';
import { environment } from 'src/environments/environment';
import { AppService } from 'src/app/app.service';
import { parsePhoneNumber, formatNumber, PhoneNumber } from 'libphonenumber-js';

import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import * as _ from 'lodash';
import moment from 'moment';

@Pipe({
    name: 'safeHtml',
    standalone: false
})
export class SafeHTMLPipe {
	constructor(private sanitizer: DomSanitizer) { }

	transform(val: string) {
		return this.sanitizer.bypassSecurityTrustHtml(val);
	}
}

@Pipe({
    name: 'safeStyle',
    standalone: false
})
export class SafeStylePipe {
	constructor(private sanitizer: DomSanitizer) { }

	transform(val: string) {
		return this.sanitizer.bypassSecurityTrustStyle(val);
	}
}

@Pipe({
    name: 'safeURL',
    standalone: false
})
export class SafeURLPipe {
	constructor(private sanitizer: DomSanitizer) { }

	transform(val: string) {
		return this.sanitizer.bypassSecurityTrustResourceUrl(val);
	}
}


@Pipe({
    name: 'ldate',
    standalone: false
})
export class LocalDatePipe {
	constructor(
		private appService: AppService
	) { }

	transform(val: any, digitsInfo?: string) {
		if (val) return moment(val).toDate().toLocaleDateString();
	}
}

@Pipe({
    name: 'lcurrency',
    standalone: false
})
export class DefaultCurrencyPipe {
	constructor(
		private appService: AppService
	) { }

	transform(val: any, digitsInfo?: string) {
		return this.appService.parseCurrency(val, digitsInfo);
	}
}

@Pipe({
    name: 'lamount',
    standalone: false
})
export class DefaultAmountPipe {
	constructor(
		private appService: AppService
	) { }

	transform(val: string, digitsInfo?: string) {
		if (!isNaN(Number(val))) val = (Number(val) / 100).toString();
		if (["US", "AU"].includes(this.appService.region)) return (new CurrencyPipe('en')).transform(val, null, this.appService.currency, digitsInfo);
		return (new CurrencyPipe('he')).transform(val, null, this.appService.currency, digitsInfo);
	}
}

@Pipe({
    name: 'paymentExp',
    standalone: false
})
export class PaymentExpiration {
	constructor() { }

	transform(val: any) {
		let m = val.expMonth
		let y = val.expYear;
		return _.padStart(m, 2, '0') + "/" + _.padStart(y, 2, '0')
	}
}

@Pipe({
    name: 'visualNumber',
    standalone: false
})
export class VisualNumberPipe {
	constructor(
		private appService: AppService
	) { }

    transform(val: string) {
        return val;
		return (new CurrencyPipe('he')).transform(val, this.appService.currency);
	}
}

@Pipe({
    name: 'translate',
    pure: false,
    standalone: false
})

export class TranslatePipe implements PipeTransform {
	constructor(private appService: AppService) {

	}
	transform(value: any, args?: any): any {
		let ret = this.appService.translate(value, args);
		return ret || value;
	}
}

@Pipe({
    name: 'objTranslate',
    pure: false,
    standalone: false
})

export class ObjTranslatePipe implements PipeTransform {
	constructor(private appService: AppService) {

	}
	transform(obj: any, prop: string, _default: string): string {
		return this.appService.objTranslate(obj, prop, _default);
	}
}

@Pipe({
    name: 'pmimage',
    pure: false,
    standalone: false
})

export class PmImagePipe implements PipeTransform {
	constructor(private appService: AppService) {

	}
	transform(value: any): any {
		let img;
		switch (value) {
			case "creditCard": img = 'creditcard.svg'; break;
			case "Cibus": img = 'cibus.png'; break;
			case "10bis": img = 'tenbis.png'; break;
			case "Meshulam": img = 'bit.png'; break;
			case "giftCard": img = 'giftcard.svg'; break;
			case "kashcash": img = 'kashcash.png'; break;
			default: img = 'other.svg';
		}
		return `/assets/pms/${img}`;
	}
}

@Pipe({
    name: 'weight',
    pure: false,
    standalone: false
})

export class WeightPipe implements PipeTransform {
	constructor(private appService: AppService) {}
	transform(value: any, unit: string = 'kg'): any {
		switch (unit) {
			case "kg":
				value *= 1000;
				unit = this.appService.translate('WEIGHT.GRAM');
				break;
		}
		return `${value} ${unit}`;
	}
}

@Pipe({
    name: 'card',
    standalone: false
})
export class CardPipe {
	constructor(
		private appService: AppService
	) { }

	transform(val: string) {
		if (val?.length > 4) {
			let arr: string[] = val.match(new RegExp('.{1,4}$|.{1,4}', 'g'));
			if (this.appService.direction == "rtl") arr = arr.reverse();
			return arr.join(" ");
		}
		return val;
	}
}

@Pipe({
    name: 'phone',
    standalone: false
})
export class PhonePipe {
	constructor(
		private appService: AppService
	) { }


	transform(tel, args?) {
		if (!tel || !tel.length) return tel;

		try {
			if (tel.includes('+')) {
				let numberInstance: PhoneNumber = parsePhoneNumber(tel);
				if (numberInstance.country == this.appService.region) {
					return numberInstance.formatNational()
				} else {
					return numberInstance.formatInternational()
				}
			}
		} catch (e) {}

		var value = tel.toString().trim().replace(/^\+/, '');
		if (value.match(/[^0-9]/)) {
			return tel;
		}
		var country, city, number;
		switch (value.length) {
			case 10: // +1PPP####### -> C (PPP) ###-####
				country = 1;
				city = value.slice(0, 3);
				number = value.slice(3);
				break;

			case 11: // +CPPP####### -> CCC (PP) ###-####
				country = value[0];
				city = value.slice(1, 4);
				number = value.slice(4);
				break;

			case 12: // +CCCPP####### -> CCC (PP) ###-####
				country = value.slice(0, 3);
				city = value.slice(3, 5);
				number = value.slice(5);
				break;

			default:
				return tel;
		}
		if (country == 1) { country = ""; }
		number = number.slice(0, 3) + '-' + number.slice(3);
		return (country + " (" + city + ") " + number).trim();
	}
}





@Pipe({
    name: 'filterBy',
    pure: false,
    standalone: false
})
//https://github.com/VadimDez/ngx-filter-pipe

export class FilterPipe implements PipeTransform {

	static isFoundOnWalking(value, key) {
		let walker = value;
		let found = false;
		do {
			if (walker.hasOwnProperty(key) || Object.getOwnPropertyDescriptor(walker, key)) {
				found = true;
				break;
			}
		} while (walker = Object.getPrototypeOf(walker));

		return found;
	}

	static isNumber(value) {
		return !isNaN(parseInt(value, 10)) && isFinite(value);
	}

	/**
	 * Checks function's value if type is function otherwise same value
	 */
	static getValue(value: any): any {
		return typeof value === 'function' ? value() : value;
	}

	private filterByString(filter) {
		if (filter) {
			filter = filter.toLowerCase();
		}
		return value => !filter || (value ? ('' + value).toLowerCase().indexOf(filter) !== -1 : false);
	}

	private filterByBoolean(filter) {
		return value => Boolean(value) === filter;
	}

	private filterByObject(filter) {
		return value => {
			for (const key in filter) {

				if (key === '$or') {
					if (!this.filterByOr(filter.$or)(FilterPipe.getValue(value))) {
						return false;
					}
					continue;
				}

				if (!FilterPipe.isFoundOnWalking(value, key)) {
					return false;
				}

				if (!this.isMatching(filter[key], FilterPipe.getValue(value[key]))) {
					return false;
				}
			}

			return true;
		};
	}

	private isMatching(filter, val) {
		switch (typeof filter) {
			case 'boolean':
				return this.filterByBoolean(filter)(val);
			case 'string':
				return this.filterByString(filter)(val);
			case 'object':
				return this.filterByObject(filter)(val);
		}
		return this.filterDefault(filter)(val);
	}

	/**
	 * Filter value by $or
	 */
	private filterByOr(filter: any[]): (value: any) => boolean {
		return (value: any) => {
			const length = filter.length;

			const arrayComparison = (i) => value.indexOf(filter[i]) !== -1;
			const otherComparison = (i) => value === filter[i];
			const comparison = Array.isArray(value) ? arrayComparison : otherComparison;

			for (let i = 0; i < length; i++) {
				if (comparison(i)) {
					return true;
				}
			}

			return false;
		};
	}

	/**
	 * Default filterDefault function
	 */
	private filterDefault(filter: any): (value: any) => boolean {
		return (value: any) => filter === undefined || filter == value;
	}

	transform(array: any[], filter: any): any {
		if (!array) {
			return array;
		}

		switch (typeof filter) {
			case 'boolean':
				return array.filter(this.filterByBoolean(filter));
			case 'string':
				if (FilterPipe.isNumber(filter)) {
					return array.filter(this.filterDefault(filter));
				}
				return array.filter(this.filterByString(filter));
			case 'object':
				return array.filter(this.filterByObject(filter));
			case 'function':
				return array.filter(filter);
		}
		return array.filter(this.filterDefault(filter));
	}
}
